export default __webpack_public_path__ + "static/media/time-managemeent.a8db0762.png";